import { useEffect } from "react";

interface JsonLdProps {
  /** Stable id so repeated renders replace the same script tag instead of stacking. */
  id: string;
  /** Valid schema.org structured data (use only factual, visible content). */
  data: Record<string, unknown>;
}

/**
 * Injects a JSON-LD structured data block into <head>.
 */
export default function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
  }, [id, data]);

  return null;
}